var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReplyLine = function SvgReplyLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.4 12.8 1.4 8l6-4.8v3a6 6 0 0 1 5.98 6.486 5.4 5.4 0 0 0-4.592-2.883L8.6 9.8H7.4zM6.2 8.6h2.42l.209.004a6.6 6.6 0 0 1 2.205.46A4.79 4.79 0 0 0 7.4 7.4H6.2V5.697L3.321 8 6.2 10.303z"
  })));
};
export default SvgReplyLine;